import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAscending = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.16663 6.85156L5.19626 2.88119C5.17049 2.85539 5.13989 2.83492 5.10621 2.82096C5.07253 2.80699 5.03642 2.7998 4.99996 2.7998C4.9635 2.7998 4.92739 2.80699 4.89371 2.82096C4.86003 2.83492 4.82943 2.85539 4.80366 2.88119L0.833292 6.85156",
		stroke: "#006ADC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAscending);
export default ForwardRef;
